export default {
  getAdminStoreList(state) {
    return state.adminStoreList;
  },

  getAdminStoreInfo(state) {
    return state.adminStoreInfo;
  },
  getCount: (state) => state.count,
  getTransaction: (state) => state.transaction,
  getSales: (state) => state.sales
};
